import {css} from '@emotion/react';
import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

export class Waiter extends React.Component {

  render() {
    return (
      <div className='sweet-loading'>
        <PulseLoader
          css={override}
          sizeUnit={"px"}
          size={16}
          color={'#0D47A1'}
          loading={this.props.loading}
        />
      </div>
    )
  }
}